module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown-save",
    attrs: {
      "id": "dropdown-save"
    }
  }, [_c('b-dropdown', {
    attrs: {
      "id": "dropdown-right",
      "right": "",
      "text": "",
      "variant": "primary"
    }
  }, [_c('b-dropdown-item', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('save_copie_html_action'),
      expression: "'save_copie_html_action'"
    }],
    attrs: {
      "id": "saveAsItem"
    },
    on: {
      "click": _vm.saveAs
    }
  }, [_vm._v(_vm._s(_vm.$t('template.save_as_copie')))]), _vm._v(" "), _c('b-dropdown-item', {
    directives: [{
      name: "has-permission",
      rawName: "v-has-permission",
      value: ('save_video_action'),
      expression: "'save_video_action'"
    }],
    attrs: {
      "id": "saveAsVideo"
    },
    on: {
      "click": _vm.saveVideo
    }
  }, [_vm._v(_vm._s(_vm.$t('template.save_as_video')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d68e17e8","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DropDown/Save.vue
// module id = 849
// module chunks = 1 3